<template>
  <div id="app">
    <tabbar></tabbar>
    <router-view />
    <banner></banner>
    <loginModule v-if="moduleFlag" />
  </div>
</template>
<script>
  import tabbar from '@/components/tabbar/index.vue'
  import banner from '@/components/banner/index.vue'
  import loginModule from "@/components/loginModule/loginModule.vue";
  import {
    mapState
  } from "vuex";
  export default {
    components: {
      tabbar,
      banner,
      loginModule
    },
    computed: {
      ...mapState("user", {
        loading: state => state.loading,
        loadingText: state => state.loadingText,
        moduleFlag: (state) => state.moduleFlag,
      }),
    },
    data() {
      return {

      }
    }
  }
</script>
<style>
  body {
    margin: 0;
    padding: 0;
  }
</style>
<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
  }

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
</style>